{
  "version": 1,
  "asset_id": "a8f08313-7cc5-46e0-9484-70341e142303",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/a8f08313-7cc5-46e0-9484-70341e142303/sleeve-fitzer-2-220.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/a8f08313-7cc5-46e0-9484-70341e142303/sleeve-fitzer-2-220.webp",
  "original_filename": "sleeve-fitzer-2-220.webp",
  "size": 4450,
  "content_type": "image/webp",
  "created_at": "2026-09-29T01:15:23Z"
}
